module.exports = __webpack_public_path__ + "img/06.3e6d5825.jpg";